// trucks.trailers is a Postgres text[] column, but every form in the app edits
// it through a plain text input. Sending the raw string makes Postgres reject
// the whole write with 22P02 "malformed array literal", which surfaced as a
// generic "Failed to create truck" toast.
//
// parseTrailers goes input -> DB, formatTrailers goes DB -> input.

/** Text input value -> text[] for the DB. Accepts "T-100" or "T-100, T-200". */
export function parseTrailers(input: string | string[] | null | undefined): string[] | null {
  if (Array.isArray(input)) {
    const cleaned = input.map(t => String(t).trim()).filter(Boolean);
    return cleaned.length ? cleaned : null;
  }
  if (!input) return null;
  const cleaned = input
    .split(',')
    .map(t => t.trim())
    .filter(Boolean);
  return cleaned.length ? cleaned : null;
}

/** DB value -> text input value. Tolerates legacy rows stored as a bare string. */
export function formatTrailers(value: string | string[] | null | undefined): string {
  if (Array.isArray(value)) return value.filter(Boolean).join(', ');
  return value || '';
}
